import http from './http';
import type { Transfer, CreateTransferRequest, TransferOffer, CreateOfferRequest, TransferFilter, TransferListResponse, TransferDetailResponse, Filter } from '@/types';

export const transferApi = {

  getListGuest: (params: TransferFilter) => http.get<TransferListResponse>('/guest-business-transfer', { params }).then((r) => r.data),

  getList: (params: TransferFilter) => http.get<TransferListResponse>('/business-transfers', { params }).then((r) => r.data),

  getById: (id: string) => http.get<TransferDetailResponse>(`/business-transfers/${id}`).then((r) => r.data.data),

  getMine: () => http.get<Transfer[]>('/business-transfers').then((r) => r.data),

  create: (body: CreateTransferRequest) => http.post<Transfer>('/business-transfers', body).then((r) => r.data),

  update: (id: string, body: Partial<CreateTransferRequest>) => http.patch<Transfer>(`/business-transfers/${id}`, body).then((r) => r.data),

  remove: (id: string) => http.delete(`/business-transfers/${id}`).then((r) => r.data),

  // Offers
  getOffers: (id: string) => http.get<TransferOffer[]>(`/business-transfers/${id}/offers`).then((r) => r.data),

  sendOffer: (body: CreateOfferRequest) => http.post<TransferOffer>(`/business-transfer-offers`, body).then((r) => r.data),

  respondOffer: (transferId: string, offerId: string, status: 'accepted' | 'rejected') =>
    http
      .patch<TransferOffer>(`/business-transfers/${transferId}/offers/${offerId}`, {
        status,
      })
      .then((r) => r.data),
};
